import { Bell } from 'lucide-react';
import * as React from 'react';
import { cn } from '@shared/utils/utils';
import { useUnreadCount } from '../../hooks';
import { NotificationBadge } from '../display/NotificationBadge';

export type NotificationBellProps = React.ComponentPropsWithoutRef<'button'>;

/**
 * Botón campana; debe ser hijo directo de PopoverTrigger asChild para que Radix
 * ancle el popover al botón (ref + posición).
 */
export const NotificationBell = React.forwardRef<HTMLButtonElement, NotificationBellProps>(
  ({ className, type, ...props }, ref) => {
    const { count } = useUnreadCount();

    return (
      <button
        ref={ref}
        type={type ?? 'button'}
        className={cn('relative p-2 rounded-md hover:bg-hover-press transition-colors', className)}
        aria-label="Notifications"
        data-testid="notification-bell"
        {...props}
      >
        <Bell className="w-5 h-5 text-icons" />
        {count > 0 && <NotificationBadge count={count} />}
      </button>
    );
  },
);
NotificationBell.displayName = 'NotificationBell';
